import {
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";
import { AxiosError } from "axios";
import { checkForcedRedirect } from "../api/checkForcedRedirect";

/**
 * Transform an AxiosError into a RequestError object
 */
export const transformAxiosToFetchBaseQueryError = (
  axiosError: AxiosError,
  blocking = false,
) => {
  const { response } = axiosError || {};
  const error = {
    status: response?.status,
    text: response?.statusText,
    data: response?.data ?? undefined,
    originalStatus: response?.status,
    code: response?.status,
    blocking,
  } as FetchBaseQueryError;
  return error;
};

/**
 * Transform an FetchBaseQueryError into a RequestError object
 */
export const transformFetchBaseQueryApiError = (
  baseQueryReturnValue: FetchBaseQueryError,
  meta?: FetchBaseQueryMeta,
  blocking = false,
) => {
  return {
    ...baseQueryReturnValue,
    text: meta?.response?.statusText,
    code: meta?.response?.status,
    blocking,
  };
};

/**
 * Transform an FetchBaseQueryError including the additional errorData with the redirect location data
 */
export const transformFetchBaseQueryErrorWithLocationRedirect = (
  baseQueryReturnValue: FetchBaseQueryError,
  meta?: FetchBaseQueryMeta,
  blocking = false,
) => {
  const location = meta?.response?.headers.get("location");
  const error = transformFetchBaseQueryApiError(
    baseQueryReturnValue,
    meta,
    blocking,
  );
  return {
    ...error,
    redirectError: checkForcedRedirect(meta?.response?.status, location),
  };
};

/**
 * Transform an AxiosError to a FetchBaseQueryError including the additional errorData with the redirect location data
 */
export const transformAxiosToFetchBaseQueryErrorWithLocationRedirect = (
  error: AxiosError,
  blocking = false,
) => {
  const { response } = error || {};
  const fetchBaseQueryError = transformAxiosToFetchBaseQueryError(
    error,
    blocking,
  );
  const location = response?.headers?.location;
  return {
    ...fetchBaseQueryError,
    redirectError: checkForcedRedirect(response?.status, location),
  };
};

export const getAuthSessionFromStorage = () => {
  const persistSession = sessionStorage.getItem("persist:root");
  let token: string | null = null;
  if (persistSession) {
    try {
      const jsonItem = JSON.parse(persistSession);
      token = jsonItem.session?.auth_token;
    } catch (e) {
      console.error("something went wrong parsing the auth-session token");
    }
  }
  return token;
};
export const getUinfoTokenFromStorage = () => {
  const persistSession = sessionStorage.getItem("persist:root");
  let token: string | null = null;
  if (persistSession) {
    try {
      const jsonItem = JSON.parse(persistSession);
      token = jsonItem.session?.uinfo;
    } catch (e) {
      console.error("something went wrong parsing the uinfo-session token");
    }
  }
  return token;
};
